import { useSnackbar } from 'notistack'
import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import { QUERY_KEYS } from 'src/constants'

import { mediaEntityUploadService } from 'src/services/media-entity-upload.service'
import { scanService } from 'src/services/scan.service'
import {
  ECreateScanMode,
  EScanRecordType,
  IScanCreateForm,
  IUnreviewedScansCountRespDto,
} from 'src/types'

type Props = IScanCreateForm & {
  record_type: EScanRecordType
  scan_mode: ECreateScanMode
}

export const useAddScan = () => {
  const { accountId } = useParams()
  const queryClient = useQueryClient()
  const { enqueueSnackbar } = useSnackbar()

  return useMutation(
    async ({ media, ...dto }: Props) => {
      const uploadedMedia = await mediaEntityUploadService.uploadMedia(media)

      return scanService.createScan({
        ...dto,
        media: uploadedMedia,
      })
    },
    {
      onSuccess(data) {
        if (!data) {
          return
        }

        queryClient.invalidateQueries([QUERY_KEYS.SCANS])

        if (data.balanceMessage) {
          setTimeout(() => {
            enqueueSnackbar(data.balanceMessage, { variant: 'warning' })
          }, 1000)
        }

        queryClient.invalidateQueries([QUERY_KEYS.SCANS_UNREVIEWED_COUNT, accountId || ''])
      },
    },
  )
}
